/* Theme-side usability safeguard. Server-side checkout validation is separate. */
(() => {
  'use strict';
  const required = '[data-ah-printify-required]';
  const designSelector = 'input[name="properties[Personalization ID]"]';
  const saved = form => [...form.querySelectorAll(designSelector)]
    .some(input => !input.disabled && input.value.trim());
  // Printify's option lookup can miss a single, non-selectable Size value.
  // Its supported form data-sku fallback identifies the exact Shopify variant.
  function syncSku(component) {
    const form = component.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    let variants;
    try { variants = JSON.parse(component.dataset.ahPrintifyVariantSkus || '[]'); }
    catch { return; }
    const id = form.querySelector('input[name="id"]')?.value;
    const variant = variants.find(item => String(item.id) === String(id));
    if (variant?.sku) {
      if (form.dataset.sku !== variant.sku) form.dataset.sku = variant.sku;
    } else {
      delete form.dataset.sku;
    }
  }
  // The app may retain a design from the previous Shopify option selection.
  // Clear it before Horizon replaces the form; a new selection needs a new save.
  document.addEventListener('change', event => {
    if (!(event.target instanceof Element)) return;
    const picker = event.target.closest('variant-picker');
    if (!picker) return;
    const section = picker.closest('.shopify-section');
    if (!section?.querySelector(required)) return;
    section.querySelectorAll('.personalize-button[id^="personalize-button-"]').forEach(button => {
      const app = window['personalize_' + button.id.slice('personalize-button-'.length)];
      if (typeof app?.clearPersonalization === 'function') app.clearPersonalization();
    });
    section.querySelectorAll(`${required} ${designSelector}`).forEach(input => input.remove());
    sync();
  }, true);
  function sync() {
    document.querySelectorAll(required).forEach(component => {
      syncSku(component);
      const form = component.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      const ready = saved(form);
      form.querySelectorAll('[data-ah-printify-button]').forEach(button => {
        if (!ready) {
          if (!button.disabled) button.disabled = true;
          if (button.dataset.ahLocked !== 'true') button.dataset.ahLocked = 'true';
        } else if (button.dataset.ahLocked === 'true') {
          // Unlock only our own lock; preserve theme loading/error/inventory states.
          button.dataset.ahLocked = 'false';
          if (button.dataset.ahAvailable === 'true') button.disabled = false;
        }
      });
      const message = form.querySelector('[data-ah-printify-message]');
      const text = ready
        ? 'Your personalized design is saved. Confirm your selected options, then add this item to your cart.'
        : 'Choose “Add personalized design” and save your design before adding this item to your cart.';
      if (message && message.textContent.trim() !== text) message.textContent = text;
    });
  }
  function stop(event, focus) {
    event.preventDefault();
    event.stopImmediatePropagation();
    focus?.focus();
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.closest(required) && !saved(form)) {
      stop(event, document.querySelector('.personalize-button'));
      sync();
      return;
    }
    const blocked = document.querySelector('[data-ah-cart-blocked]');
    if (blocked && (event.submitter?.name === 'checkout' || /\/checkout/.test(form.action))) {
      stop(event, blocked);
    }
  }, true);
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    // Run before Printify's inline opener, including after a section rerender.
    if (event.target.closest('.personalize-button')) {
      const section = event.target.closest('.shopify-section');
      section?.querySelectorAll(required).forEach(syncSku);
    }
    const button = event.target.closest('[data-ah-printify-button]');
    if (button?.form && !saved(button.form)) {
      stop(event, document.querySelector('.personalize-button'));
      sync();
      return;
    }
    const blocked = document.querySelector('[data-ah-cart-blocked]');
    const checkout = event.target.closest('[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]');
    if (blocked && checkout) stop(event, blocked);
  }, true);
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; sync(); });
  };
  new MutationObserver(schedule).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['value', 'disabled', 'data-ah-available']
  });
  document.addEventListener('input', schedule, true);
  document.addEventListener('change', schedule, true);
  document.addEventListener('shopify:section:load', schedule);
  sync();
})();
